import CostcallPage from "../pages/CostcallPage/CostcallPage";
import MainPage from "../pages/MainPage/MainPage";



export const routes = [
    // { path: '/', element: MainPage },
    { path: '*', element: CostcallPage },

];


